import api from "./api";

export const fetchPolicies =
    async () => {
        try {
            const response =
                await api.get(
                    "/terms-and-policies-management/all"
                );

            return {
                success: true,
                data:
                    response.data
                        .data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error
                        ?.response
                        ?.data
                        ?.detail ||
                    "Failed to fetch policies.",
            };
        }
    };